import { Button } from 'antd';
import { BoldOutlined } from '@ant-design/icons';
import { FormattedMessage } from 'react-intl';

const Bold = ({ editor, showLabel = false }) => {
  return (
    <Button
      className={`editor-toolbar-btn-container ${editor.isActive('bold') ? '!bg-slate-100 text-black' : '!bg-transparent'}`}
      icon={<BoldOutlined className="text-gray-800 text-xs" />}
      onClick={() => editor.chain().focus().toggleBold().run()}
      size="small"
      type="text"
    >
      {showLabel && (
        <div className="editor-toolbar-btn-label">
          <FormattedMessage id="BOLD" defaultMessage="Bold" />
        </div>
      )}
    </Button>
  );
};

export default Bold;
